export async function getCitiesFromState(country, state, addressLocationsRepository) {
  
    const result = await addressLocationsRepository.get_cities_from_state(country, state);

    if (result.status == 200) return result.data;
}